<template>
  <div class="card p-3 mb-3 alerta-grupo-ocorrencias">
    <div class="">
      <span class="badge badge-danger">Cancelamentos</span>
      <h5 class="font-weight-bolder mt-1 mb-0">{{ titulo }}</h5>
    </div>

    <div class="mt-3">
      <div v-for="alerta in alertas" :key="alerta.id" class="ocorrencia-item border-top py-2">
        <div>
          <div>
            <div v-if="alerta.mensagem">{{ alerta.mensagem }}</div>
          </div>
          <div class="d-flex align-items-center">
            <div v-if="alerta.criadoEm" class="small mr-2">{{ formatarData(alerta.criadoEm) }}</div>
            <button v-if="alerta.pedidoId" class="btn btn-sm text-info flex-shrink-0"
                    @click="$emit('ver-pedido', alerta.pedidoId)">
              Ver pedido
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center border-top pt-2 mt-2">
      <button class="btn btn-primary btn-sm ml-2 px-3" @click="$emit('ignorar', alertas)">Limpar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertaGrupoOcorrencias',
  props: {
    alertas: { type: Array, required: true }
  },
  computed: {
    titulo() {
      return this.alertas.length === 1
        ? '1 pedido cancelado'
        : `${this.alertas.length} pedidos cancelados`;
    }
  },
  methods: {
    formatarData(data) {
      return this.$dayjs(data).format('DD/MM/YYYY - HH:mm');
    }
  }
}
</script>

<style scoped>
.ocorrencia-item:last-child { padding-bottom: 0 !important; }
</style>
